import { SecureAction } from '../secure-actions';

export class ModelDetailSensorTypeSecureAction extends SecureAction {
  public static readonly VIEW: SecureAction = new ModelDetailSensorTypeSecureAction(`settings:model:details|${SecureAction.VERBS.VIEW}`);
  public static readonly CREATE: SecureAction = new ModelDetailSensorTypeSecureAction(
    `settings:model:details|${SecureAction.VERBS.CREATE}`,
  );
  public static readonly UPDATE: SecureAction = new ModelDetailSensorTypeSecureAction(`settings:model:details|update`);
  public static readonly DELETE: SecureAction = new ModelDetailSensorTypeSecureAction(
    `settings:model:details|${SecureAction.VERBS.DELETE}`,
  );

  private constructor(name: string) {
    super(name);
  }
}
